import { useQuery } from "@apollo/client";
import { featuredCardsGQL, Query } from "@onmo/graphql/graphql";

export const useFeaturedCards = () => {
  const { data: featuredCardsData } = useQuery<{
    featuredCards: Query["featuredCards"];
  }>(featuredCardsGQL, {
    variables: { input: { group: "main" } },
  });
  const homeFeed = featuredCardsData?.featuredCards?.items;

  return homeFeed;
};
